// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap__odTlo","Completion":"index_Completion__QiiV6","viewBox":"index_viewBox__VK1W-"};